import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-native-multi-level-selector"
    }}>{`react-native-multi-level-selector`}</h1>
    <p>{`React Native component for Multi level options Selector for your application.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save react-native-multi-level-selector
`}</code></pre>
    <p>{`##Update Log`}</p>
    <ul>
      <li parentName="ul">{`Removed react native vector icons dependency`}</li>
      <li parentName="ul">{`Users do not have to enter the id themselves manually thus improving developer experience. (Careful of the level of your nesting though)`}</li>
    </ul>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-Javascript"
      }}>{`import React from 'react';
import {View, StyleSheet, Text} from 'react-native';

import DropDown from 'react-native-multi-level-selector';

const App = () => {
  const options = [
    {
      value: 'Department',
      nested: [
        {value: 'Customer Relations'},
        {value: 'IT'},
        {value: 'Human Resources'},
        {value: 'Managerial'},
      ],
    },
    {
      value: 'Location',
      nested: [
        {
          value: 'Bangalore',
          nested: [
            {
              value: 'Whitefield',
              nested: [
                {
                  value: 'ITPL',
                },
              ],
            },
            {
              value: 'Jayanagar',
            },
            {
              value: 'Majestic',
            },
          ],
        },
        {
          value: 'New York',
          nested: [
            {
              value: "Hell's Kitchen",
            },
            {
              value: 'Harlem',
            },
          ],
        },
        {value: 'Birmingham'},
      ],
    },
    {
      value: 'Role',
      nested: [
        {
          value: 'SDE 1',
          nested: [
            {
              value: 'Trainee',
            },
            {
              value: 'Associate',
            },
          ],
        },
        {value: 'SDE 2'},
        {value: 'SDE 3'},
      ],
    },
  ];

  return (
    <View>
      <DropDown placeholder="Filter" onChange={el => {}} options={options} />
      <Text style={styles.content}>Your Content Goes Here</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  content: {textAlign: 'center', fontSize: 20, marginVertical: 20},
});

export default App;

`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`options`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{Array}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Required) Options for the dropdown. Specify the options for users to select from.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`placeholder`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{String}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Required) The text displayed when no option is selected.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`onChange`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{function}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Subscribe to change events.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`inputUnderlayColor`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{String}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Underlay color for the TouchableHighlight Input. Default is white`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`optionContainerStyles`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{Object}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Styles for the input.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`optionTextWrapperStyles`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{Object}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Styles for Option List Wrapper`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`optionsIconStyles`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{Object}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Styles for the icons`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`optionTextStyles`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{Object}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text styles for options`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      